import React, { Component } from 'react'
import {
  FacebookShareButton,
  // GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  // TelegramShareButton,
  // WhatsappShareButton,
  // PinterestShareButton,
  // VKShareButton,
  // OKShareButton,
  // RedditShareButton,
  // TumblrShareButton,
  // LivejournalShareButton,
  // MailruShareButton,
  // ViberShareButton,
  // WorkplaceShareButton,
  EmailShareButton,
} from 'react-share';
import AccessibleShareButton from './AccessibleShareButton';
//import SocialShareMore from './SocialShareMore'
// import './SocialShare.css'

class SocialShare extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showMore: false
    }
  }

  socialShareMoreOnClick = ( e ) => {
    let showMore = this.state.showMore ? false : true
    this.setState({
      showMore: showMore
    })
  }

  print() {
    window.print()
  }

  render() {
    let renderClassName = "social-share"
    /*
    let moreButtonTitle = "Afficher plus de boutons de partage"
    if (this.state.showMore === true) {
      renderClassName += " social-share-open"
      moreButtonTitle = "Masquer les boutons de partage"
    }
    */

    return (
      <div className={renderClassName}>
        <button className="SocialMediaShareButton SocialMediaShareButton--print" title="Imprimer la page" aria-label="Imprimer la page" onClick={this.print} >&nbsp;</button>
        <AccessibleShareButton 
          ShareButton={EmailShareButton} 
          url={this.props.shareUrl} 
          title="Partager par mail" 
          aria-label="Partager par mail" 
          subject={(this.props.subject ? this.props.subject : "")}
        />
        <AccessibleShareButton 
          ShareButton={FacebookShareButton} 
          url={this.props.shareUrl} 
          aria-label="Partager sur Facebook"
        />
        <AccessibleShareButton 
          ShareButton={TwitterShareButton} 
          url={this.props.shareUrl} 
          title="Partager sur Twitter" 
          aria-label="Partager sur Twitter"
        />
        <AccessibleShareButton 
          ShareButton={LinkedinShareButton} 
          url={this.props.shareUrl} 
          title="Partager sur Linkedin" 
          aria-label="Partager sur Linkedin"
        />
        {/*
          <button title={moreButtonTitle} className="SocialMediaShareButton SocialMediaShareButton--plus" onClick={this.socialShareMoreOnClick} />
          <SocialShareMore shareUrl={this.props.shareUrl} subject={this.props.subject}/>
        */}
      </div>
    )
  }
}

export default SocialShare
